import React,{useState} from 'react'
import {toPersianNumber} from "../utils/numberConversion";
import {toast} from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import {DatePicker} from "zaman";
function AdminBundleCard({bundle, onClickCard,onDeleteClick,onFilesClick,navigator, newExam = false,NewExamTitle='آزمون جدید'}) {
    const [active,setActive] = useState(bundle ? bundle.is_active===true : false)
    const [downloadable,setDownloadable] = useState(bundle ? bundle.is_downloadable===true : false)
    const handleClick = async () => {
        try {
            const response = await api.post("/api/bundle/status/update",{
                bundle_id : bundle?.id
            });
            setActive(response.data.status)
            toast.success(response.data.message, {
                position: "bottom-right"
            });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    const handleDownloadClick = async () => {
        try {
            const response = await api.post("/api/bundle/status/download",{
                bundle_id : bundle?.id
            });
            setDownloadable(response.data.status)
            toast.success(response.data.message, {
                position: "bottom-right"
            });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    if (newExam) {
        return (<div className="col-lg-3 col-11 p-2">
            <div className="admin-exam-card" style={{height:'25vh'}}>
                <div className="d-flex flex-row align-items-center px-4">
                    <h5 className={'exam-card-title'}>{NewExamTitle}</h5>
                </div>
                <button className="btn btn-filled col-10 my-5" onClick={onClickCard}>ساخت {NewExamTitle}</button>
            </div>
        </div>);
    }
    return (<div className="col-lg-3 col-11 p-2">
        <div className="admin-exam-card" style={{height:'25vh'}}>
            <div className="d-flex flex-row align-items-center px-4">
                <h5 className={'exam-card-title'}>{bundle.display_name}</h5>
                <button className={`btn ${!active ? 'btn-outline-red' : 'btn-outline-blue'}`} onClick={handleClick}
                        style={{padding: '.2rem .3rem', fontSize: '.7rem'}}>
                    {!active ? 'غیرفعال' : 'فعال'}
                </button>
                <button className={`btn ${!downloadable ? 'btn-outline-red' : 'btn-outline-blue'} mx-1`}
                        onClick={handleDownloadClick}
                        style={{padding: '.2rem .3rem', fontSize: '.7rem'}}>
                    {!downloadable ? 'دانلود غیرفعال' : 'دانلود فعال'}
                </button>
            </div>
            <div className="d-flex flex-column align-items-start px-5">
                <p>
                    قیمت :

                    <span>{bundle.total_price === 0 ? 'رایگان' : toPersianNumber(bundle.total_price) + ' تومان '}</span>
                </p>

            </div>
            <div className="d-flex flex-row justify-content-around py-2">
                <button className="btn btn-outline-red" onClick={onDeleteClick}>حذف فایل ها</button>
                <button className="btn btn-outline-blue " onClick={onClickCard}>ویرایش</button>
                <button className="btn btn-outline-blue " onClick={onFilesClick}>افزودن فایل</button>

            </div>
        </div>
    </div>);
}

export default AdminBundleCard;
